import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
} from 'axis-components';
import { CommonModule,JsonPipe, SlicePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { BaseRules, TextValues } from './michigan.model';
import { PipBaseStateComponent } from '../pip-base-state.component';
import {
  PersonalInjuryProtectionSelection,
} from '../../../config/pip-constants';

@Component({
  selector: 'app-michigan',
  templateUrl: './michigan.component.html',
  styleUrls: ['./michigan.component.scss'],
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    DropdownModule,
    CommonModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    JsonPipe,
  ],
})
export class MichiganComponent extends PipBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('michigan', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('michigan', null);
    }
  }
}
